var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';

var TabsTab = (_temp = _class = function (_Component) {
    _inherits(TabsTab, _Component);

    function TabsTab() {
        _classCallCheck(this, TabsTab);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    TabsTab.prototype.render = function render() {
        var _this2 = this,
            _extends2;

        var _props = this.props,
            children = _props.children,
            className = _props.className,
            disabled = _props.disabled,
            disabledClassName = _props.disabledClassName,
            focus = _props.focus,
            id = _props.id,
            panelId = _props.panelId,
            selected = _props.selected,
            selectedClassName = _props.selectedClassName,
            tabIndex = _props.tabIndex,
            tabRef = _props.tabRef,
            name = _props.name,
            value = _props.value,
            attributes = _objectWithoutProperties(_props, ['children', 'className', 'disabled', 'disabledClassName', 'focus', 'id', 'panelId', 'selected', 'selectedClassName', 'tabIndex', 'tabRef', 'name', 'value']);

        return React.createElement(
            'button',
            _extends({}, attributes, (_extends2 = {
                className: className, role: 'tab',
                ref: function ref(node) {
                    _this2.node = node;
                    if (tabRef) tabRef(node);
                }
            }, _extends2['role'] = 'tab', _extends2.name = name, _extends2.id = id, _extends2.value = value, _extends2['aria-selected'] = selected ? 'true' : 'false', _extends2['aria-disabled'] = disabled ? 'true' : 'false', _extends2['aria-controls'] = panelId, _extends2.tabIndex = tabIndex || (selected ? '0' : null), _extends2.onClick = this.onSelect, _extends2)),
            this.props.children
        );
    };

    return TabsTab;
}(Component), _class.defaultProps = {
    className: "admin-tabs__tab",
    focus: false,
    id: null,
    panelId: null,
    selected: false
}, _temp);


export default TabsTab;